import Hero from "@/pages/home/components/Hero";
import HomeNews from "@/pages/home/components/HomeNews";
import HomeTopics from "@/pages/home/components/HomeTopics";
import HomeFeatured from "@/pages/home/components/HomeFeatured";
import HomeVoices from "@/pages/home/components/HomeVoices";
import HomeSubscribe from "@/pages/home/components/HomeSubscribe";
import { useSeo } from "@/hooks/useSeo";
import { articles } from "@/utils/content";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  useSeo({
    title: "瓜田秘闻社 - 圈内八卦内幕与娱乐小道消息每日放送",
    description:
      "瓜田秘闻社是圈内八卦内幕聚集地，每日放送娱乐八卦、剧组秘闻、综艺内幕与幕后故事，帮你深扒事件来龙去脉，轻松掌握每天的新鲜瓜。",
    keywords: "黑料吃瓜,圈内八卦,娱乐内幕,吃瓜爆料,小道消息",
    canonical: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: siteInfo.name,
          url: "https://sdbjdz.cn/",
          description: siteInfo.description,
          inLanguage: "zh-CN",
          potentialAction: {
            "@type": "SearchAction",
            target:
              "https://sdbjdz.cn/news?keyword={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "Organization",
          name: siteInfo.name,
          url: "https://sdbjdz.cn/",
          email: siteInfo.email,
        },
        {
          "@type": "ItemList",
          name: "今日吃瓜快讯",
          itemListElement: articles.slice(0, 6).map((article, index) => ({
            "@type": "ListItem",
            position: index + 1,
            url: `https://sdbjdz.cn/article/${article.id}`,
            name: article.title,
          })),
        },
      ],
    },
  });

  return (
    <>
      <Hero />
      <HomeNews />
      <HomeTopics />
      <HomeFeatured />
      <HomeVoices />
      <HomeSubscribe />
    </>
  );
}